import React, { Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import CommonFrom from "../../../Common/Components/Form";
import { FormSubmit, getProvinces, getCity } from "./Components/Services";

export const input = [
  {
    input: "createRegion",
    size: "col-12",
    name: "name",
    label: "نام منطقه",
  },
];
function Create() {
  const initialState = {
    loading: false,
  };
  const [state, setstate] = useState(initialState);

  const Handler = data => {
    setstate({ loading: true });
    FormSubmit(data).then(() => {
      setstate({
        loading: false,
      });
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | ثبت منطقه</title>
      </Helmet>

      <CommonFrom
        form={input}
        loading={state.loading}
        header="ایجاد منطقه"
        textbtn="لیست منطقه ها"
        linkbtn="/Admin/Region/List"
        btnName="ایجاد منطقه"
        methods={{ getProvinces, getCity }}
        submit={Handler}
      />
    </Fragment>
  );
}

export default Create;
